import { render, staticRenderFns } from "./DateBehaviorEditor.vue?vue&type=template&id=5d8de216&scoped=true&"
import script from "./DateBehaviorEditor.vue?vue&type=script&lang=ts&"
export * from "./DateBehaviorEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8de216",
  null
  
)

export default component.exports